exports.Tracking = {  
  trackPageImpression: function (page, id) {
    const pageID = `nnd-${id.trim().replace(/ /g, '').toLocaleLowerCase()}`
    const pageNAME = page.trim().replace(/ /g, '_').toLocaleLowerCase()
    const trackingCode = [pageID, pageNAME].join(' | ').replace(/\|/g, ':').toLocaleLowerCase()
    if (process.env.NODE_ENV === 'production' && typeof window.mready !== 'undefined' && typeof window.utag_data !== 'undefined') {
      try {
        window['utag_data'] = window['utag_data'] || {}
        window['mready'] = window['mready'] || []
        window['mready']['push'](function (metrics) {
          metrics['ev']({
            'events': ['event9'],
            'eVar25': trackingCode,
            'prop10': (window['utag_data']['dom.url']) ? window['utag_data']['dom.url'] : 'D=v10',
            'prop16': (window['utag_data']['net_content_type'] === 'tablet') ? 'ms|tablet' : 'D=v16',
            'prop17': (window['utag_data']['net_content_type'] === 'tablet') ? 'ms|tablet' : 'D=v17'
          })
        })
      } catch (e) {
        try {
          if (typeof window.console !== 'undefined' && typeof window.console.warn !== 'undefined') {
            window.console.warn('Logging error (mready): ', e.message)
          }
        } catch (ee) { }
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ../NodeModules/nnd-track-page/index.js
// module id = jeHi
// module chunks = 1